import * as React from 'react';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Button } from '@/components/atoms/button';
import { Input } from '@/components/atoms/input';
import {Form, FormControl, FormField, FormLabel, FormItem, FormMessage } from '@/components/atoms/form';
import {zodResolver} from '@hookform/resolvers/zod';
import {doLogin} from '@/services.ts';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/atoms/card';
import { BackButton } from '@/components/atoms/BackButton';

export const Route = createFileRoute('/my-account')({
  component: MyAccount,
});

const loginFormSchema = z.object({
  email: z.string().email(),
  passwd: z.string(),
});

function MyAccount() {
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof loginFormSchema>>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      email: 'davkon@gmail.com',
      passwd: '3cs8wt26'
    }
  });

  const onSubmit = (values: z.infer<typeof loginFormSchema>) => {
    doLogin(values.email, values.passwd).then(loginSuccess=> {
      if(loginSuccess) {
        if(window) {
          const userLoggedIn = new CustomEvent('userStatus', {
            bubbles: true,
            detail: {
              isLoggedIn: loginSuccess
            }
          });
          const rootElement = document.getElementById('root');
          if(rootElement) {
            rootElement.dispatchEvent(userLoggedIn);
          }
        }
        navigate({ to: '/account/home'});
      }
    });
  }
  return(
    <div className="main-content mb-16">
      <BackButton />
      <h1 className="text-3xl font-thin mt-8">Account Sign-In</h1>
      <Card className="w-full max-w-md mt-2">
        <CardHeader>
          <CardTitle>Welcome Back</CardTitle>
          <CardDescription>Please sign-in to manage your account, save quotes and for quick and easy checkouts.</CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form id="loginForm" onSubmit={form.handleSubmit(onSubmit)} className="space-y-4" method="post" action="/api/account/auth">
              <input type="hidden" name="redirectUrl" value="/account/home" />
              <input type="hidden" name="redirectFailedUrl" value="/account/sign-in?error=Login%20failed" />
              <FormField
                control={form.control}
                name="email"
                render={({field}) => (
                  <FormItem>
                    <FormLabel>Email address</FormLabel>
                    <FormControl>
                      <Input placeholder="eg. john.smith@gmail.com" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>)}
              />
              <FormField
                control={form.control}
                name="passwd"
                render={({field }) => (
                  <FormItem>
                    <FormLabel>Password</FormLabel>
                    <FormControl>
                      <Input type="password" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>)}
              />
            </form>
          </Form>
        </CardContent>
        <CardFooter className="flex flex-col gap-4">
          <Button type="submit" form="loginForm" className="w-full">Login</Button>
          <Button variant="secondary" type="submit" form="loginForm" className="w-full">Forgot my Password</Button>
        </CardFooter>
      </Card>
      <Card className="w-full max-w-md mt-8">
        <CardHeader>
          <CardTitle>Create New Account</CardTitle>
          <CardDescription>It's free, quick and easy to create a new account.</CardDescription>
        </CardHeader>
        <CardFooter>
          <Link to="/sign-up">
            <Button className="w-full">Create New Account </Button>
          </Link>
        </CardFooter>
      </Card>
    </div>
  )
}
